module.exports = __webpack_public_path__ + "img/pg2-title-sub-inner.8c67eb83.png";